import { render, staticRenderFns } from "./ChannelGroupWeightsSidebar.vue?vue&type=template&id=43508450&"
import script from "./ChannelGroupWeightsSidebar.vue?vue&type=script&lang=js&"
export * from "./ChannelGroupWeightsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChannelGroupWeightsSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports